// extracted by mini-css-extract-plugin
module.exports = {"bb":"bb__O8c8z","bb-related-products":"bb-related-products__eArE2"};